

export default function Social() {
    return (
        <div>
            Social
        </div>
    )
}
